import React from 'react'
import styled from "styled-components";

import Hamburger from './hamburger';

const FabComponent = styled.div`
    position: fixed;
    width: 64px;
    height: 64px;
    border-radius: 50%;
    background: ${props => props.isActive? '#EB3D35' : '#fff'};;
    bottom: 0;
    right: 0;
    margin: 16px;
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.16);
    transition: all .5s ease;
    &:hover {
      cursor: pointer;
    }
`;

const FabButton = (props) => (
  <FabComponent onClick={props.toggleFab} isActive={props.isActive} >
    <Hamburger isActive={props.isActive} />
  </FabComponent>
);

export default FabButton


// WEBPACK FOOTER //
// ./src/components/MobNav/fabButton.js